export const subtitles = {
    "1": {
        "startTime": 5.02,
        "endTime": 9.7,
        "transcript": "Annabelle Olik, Kuiggluk, Iiguaq Yugcetun.",
        "translation": "Annabelle Olik, Kwethluk, Iiguaq in Yup'ik."
    },
    "2": {
        "startTime": 10.035,
        "endTime": 16.565,
        "transcript": "Kitak' ciumek, nutem-qaa Kuigglugmiunguuten?",
        "translation": "So first, are you originally from Kwethluk?"
    },
    "3": {
        "startTime": 16.565,
        "endTime": 22.7,
        "transcript": "Kuigglugmiungunritua nutem. Nanvarnarrlagmiunguunga; Akulmiunguunga.",
        "translation": "I'm not originally from Kwethluk. I'm from Nanvarnarrlak; I'm from the Akula region."
    },
    "4": {
        "startTime": 22.7,
        "endTime": 23.61,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "5": {
        "startTime": 24.21,
        "endTime": 35.52,
        "transcript": "Kitak' tamakunek qalamciarteqernga ak'allarnek nasaurluullevni up'nerkiyalallevnek.",
        "translation": "Now, please tell me old stories of when you wen to spring camp when you were a girl."
    },
    "6": {
        "startTime": 35.76,
        "endTime": 37.73,
        "transcript": "Anglanarqelallruut?",
        "translation": "Were they fun?"
    },
    "7": {
        "startTime": 37.89,
        "endTime": 41.93,
        "transcript": "Anglanarqelallrulria-wa yuilquq.",
        "translation": "The wilderness was fun."
    },
    "8": {
        "startTime": 41.935,
        "endTime": 52.445,
        "transcript": "Nasaurluullemni miklemni, miklemni elliraurpailegma tau͡gaam Akulmi uitatullruunga.",
        "translation": "When I was a little girls, when I was small but before I was orphaned, I used to live in the Akula region."
    },
    "9": {
        "startTime": 52.445,
        "endTime": 64.14,
        "transcript": "Tua-i-llu taukuk, tamana, tamatum mikellma ayuqucian akulii nalluaqa",
        "translation": "Then those [times], I don't know what it was like when I was small"
    },
    "10": {
        "startTime": 64.14,
        "endTime": 66.65,
        "transcript": "Miklua elliraurtellruama.",
        "translation": "Because I was orphaned when I was small."
    },
    "11": {
        "startTime": 66.65,
        "endTime": 77.25,
        "transcript": "Tang ellangaqlua ayautetullruagnga up'nerkami Taklirrlagmun amavet.",
        "translation": "You see, I have early memories of them taking to Taklirrlak over there in the spring."
    },
    "12": {
        "startTime": 77.625,
        "endTime": 80.175,
        "transcript": "Taklirrlak nallunritan?",
        "translation": "You know Taklirrlak?"
    },
    "13": {
        "startTime": 80.285,
        "endTime": 85.0,
        "transcript": "Taklirrlagmun amavet, kuicuaraam iluanun tuavet.",
        "translation": "To Taklirrlak over there, in the small river there."
    },
    "14": {
        "startTime": 85.0,
        "endTime": 92.93,
        "transcript": "Nunalgutarluta-llu cali yugnek ukunek Beaver-aankunek.",
        "translation": "And there were people in our hometown, this Beaver family."
    },
    "15": {
        "startTime": 92.93,
        "endTime": 100.58,
        "transcript": "Imkunek Anguksuaraankut angayuqaatnek ilangqerturatullruukut.",
        "translation": "Anguksuar and family's parents were always with us."
    },
    "16": {
        "startTime": 100.85,
        "endTime": 106.8,
        "transcript": "Tua-i wiinga pissuryaurpailegma tamaani",
        "translation": "Before I started hunting back then"
    },
    "17": {
        "startTime": 108.06,
        "endTime": 118.18,
        "transcript": "Ukut angutet ayagaluteng kanaqlagcurluteng.",
        "translation": "These men would travel to hunt muskrats."
    },
    "18": {
        "startTime": 118.185,
        "endTime": 126.725,
        "transcript": "Piciatun ut'rutaqluteng cuignilngurnek, wall'u paluqtarnek, wall'u yaqulegnek.",
        "translation": "They would bring home various things, land otters, or beavers, or birds."
    },
    "19": {
        "startTime": 127.93,
        "endTime": 132.65,
        "transcript": "Una-llu unisteka murilkartellemni cali",
        "translation": "And when I observed my late parent"
    },
    "20": {
        "startTime": 133.465,
        "endTime": 143.52,
        "transcript": "Maligtaqamni piyuagurlunuk, kingunrakun piyuagurlua utaqaqa'aqlua ayagturalalria.",
        "translation": "When I went walking with him, walking behind him, he would go periodically waiting for me."
    },
    "21": {
        "startTime": 143.52,
        "endTime": 149.31,
        "transcript": "Kuicuarmun-llu tekicami taluyat nuggluki.",
        "translation": "And when we reached a creek, he would take out the fish trap."
    },
    "22": {
        "startTime": 149.31,
        "endTime": 153.28,
        "transcript": "Nuggnaurai can'giirnek imarluteng.",
        "translation": "He would take them out and they'd be filled with blackfish."
    },
    "23": {
        "startTime": 153.28,
        "endTime": 157.02,
        "transcript": "Tua-i-ll' kalngaminun ekluki.",
        "translation": "Then he'd put them in his reed bag for fish."
    },
    "24": {
        "startTime": 158.905,
        "endTime": 163.425,
        "transcript": "Ataam cali civqaarluki cali uterrluni.",
        "translation": "After setting it once again, he'd go home."
    },
    "25": {
        "startTime": 163.92,
        "endTime": 170.82,
        "transcript": "Utercan ava-i cali wiinga kingunrakun piurlua, paallagaqlua tua-i.",
        "translation": "When he went home, I'd also go behind him, occassionally tripping."
    },
    "26": {
        "startTime": 170.825,
        "endTime": 175.975,
        "transcript": "Pinialama paallagaqlua tayima tua-i pilalrianga.",
        "translation": "Because I was weak, I would trip."
    },
    "27": {
        "startTime": 176.035,
        "endTime": 183.83,
        "transcript": "Tua-i-llu tekicami keninritaqamiki nuutekiurluki nuvluki.",
        "translation": "Then when he arrived, if he didn't cook them, he'd thread them through to make [?nuutekat]."
    },
    "28": {
        "startTime": 183.83,
        "endTime": 193.37,
        "transcript": "Kik'ikika neqliari luqruuyiit, can'giiret.",
        "translation": "There were so many of the fish he cut, loche, blackfish."
    },
    "29": {
        "startTime": 193.375,
        "endTime": 198.31,
        "transcript": "Yaqulget-llu cipneteng agarquatullruamegteki.",
        "translation": "Because they also hung their excess birds."
    },
    "30": {
        "startTime": 198.31,
        "endTime": 203.92,
        "transcript": "Kuvyirluteng-llu kanavet ket'meggnun.",
        "translation": "And they'd set drift nets down there in the water next to them."
    },
    "31": {
        "startTime": 203.92,
        "endTime": 212.09,
        "transcript": "Cali luqruuyagglainarnek atam au͡gna neqengqertuq. Neqpianek neqengqessuunani.",
        "translation": "Also, there are only loche over there, you see. It doesn't have salmon."
    },
    "32": {
        "startTime": 212.09,
        "endTime": 221.6,
        "transcript": "Tua-i luqruuyiit can'giiret-llu kiingita neqekluki au͡g'um Tevyaram yaatiin.",
        "translation": "The only fish are loch and blackfish over there, over from Tegyaraq."
    },
    "33": {
        "startTime": 221.6,
        "endTime": 228.02,
        "transcript": "Tua-i-llu cali ayagaqan maligtelaqeka.",
        "translation": "Then I would also go with him when he traveled."
    },
    "34": {
        "startTime": 228.335,
        "endTime": 236.825,
        "transcript": "Tamatum Taklirrliim ceńiinun imumun etgalngurmun piluni.",
        "translation": "He would go the the banks of Taklirrlak to a shallow place."
    },
    "35": {
        "startTime": 236.825,
        "endTime": 240.215,
        "transcript": "Muragnek waten piluni.",
        "translation": "He would do this with wood."
    },
    "36": {
        "startTime": 240.215,
        "endTime": 245.495,
        "transcript": "Negacuararugaat-wa waten ayuqluteng.",
        "translation": "Many little snares would be like this."
    },
    "37": {
        "startTime": 246.22,
        "endTime": 248.14,
        "transcript": "They call them negarat.",
        "translation": "They call them negarat."
    },
    "38": {
        "startTime": 248.275,
        "endTime": 251.99,
        "transcript": "Wiinga tua-i tangvauralaqeka keluakun.",
        "translation": "I would watch him inland from him."
    },
    "39": {
        "startTime": 251.99,
        "endTime": 257.83,
        "transcript": "Negarat-gguq waten pingayun waten stick-at au͡gkut muriit.",
        "translation": "Those three of what he called negarat [snares], those wooden sticks."
    },
    "40": {
        "startTime": 258.485,
        "endTime": 264.275,
        "transcript": "Tamakucinek waten negarayagarnek, neganek.",
        "translation": "Those kinds of little snares like this, snares."
    },
    "41": {
        "startTime": 264.535,
        "endTime": 270.215,
        "transcript": "Tua-i-llu amiirluku yaqulek.",
        "translation": "Then he'd skin the bird."
    },
    "42": {
        "startTime": 270.85,
        "endTime": 275.93,
        "transcript": "Tua-i amiirluku, yaquk-llu uitaurtellukek.",
        "translation": "He'd skin it, and leave the wings in place."
    },
    "43": {
        "startTime": 275.935,
        "endTime": 283.365,
        "transcript": "Muragmek kapluku, urunek imirraarluku, taukut akuliitnun elliluku.",
        "translation": "He stuck a piece of wood, then after filling it with moss, he'd put it between those."
    },
    "44": {
        "startTime": 283.465,
        "endTime": 290.98,
        "transcript": "Tua-i-llu nauwa tayima paqtaqaki maligquralaqka.",
        "translation": "Then when he would check on them somewhere, I'd always go with him."
    },
    "45": {
        "startTime": 290.98,
        "endTime": 298.37,
        "transcript": "Tua-i-llu tekniaupuk, keluirnaupuk",
        "translation": "Then we would come to them from inland"
    },
    "46": {
        "startTime": 298.37,
        "endTime": 307.06,
        "transcript": "Ik'ikika yaqiulriit, yaqiplalriit imkut waten pingayun.",
        "translation": "There were so many flapping their wings in three [snares] like this."
    },
    "47": {
        "startTime": 307.95,
        "endTime": 311.65,
        "transcript": "Waten kapungqaluteng piit.",
        "translation": "These parts were stuck [in the ground] like this."
    },
    "48": {
        "startTime": 311.655,
        "endTime": 314.33,
        "transcript": "Makut-wa negat.",
        "translation": "Here were the snares."
    },
    "49": {
        "startTime": 314.33,
        "endTime": 321.12,
        "transcript": "Ik'iki allgiaraat, kukumyaraat cangtait.",
        "translation": "There'd be so many long-tailed ducks, black scoters caught in them."
    },
    "50": {
        "startTime": 321.12,
        "endTime": 327.7,
        "transcript": "Kan'a imna mit'aruara ullagyugluku.",
        "translation": "They were drawn to that bird decoy down there."
    },
    "51": {
        "startTime": 327.705,
        "endTime": 334.765,
        "transcript": "Ullagluki ivrarturluni, au͡g'arluki, uyaqurrit-ll' im['urluki].",
        "translation": "He would wade to them, take them out, and [snap] their necks."
    },
    "52": {
        "startTime": 335.41,
        "endTime": 339.45,
        "transcript": "Au͡g'arraarluki uyaqurritgun piurluki.",
        "translation": "After he removed them, he'd [snap] their necks."
    },
    "53": {
        "startTime": 339.595,
        "endTime": 347.085,
        "transcript": "Maavet naqugutminun maavet kaugaruqurluki.",
        "translation": "He would stick them into his belt here."
    },
    "54": {
        "startTime": 347.425,
        "endTime": 353.015,
        "transcript": "Tua-i-ll' amlleriata tagluni cali, allat cali au͡g'arluki.",
        "translation": "Then when they'd amassed, he'd go inland, then take others off."
    },
    "55": {
        "startTime": 353.015,
        "endTime": 357.89,
        "transcript": "Nutaan-llu nang'ngata kitugqurluki imkut negat.",
        "translation": "Then when there were no more, he'd reset the snares."
    },
    "56": {
        "startTime": 357.89,
        "endTime": 361.27,
        "transcript": "Kitugqurluki nutaan unilluki.",
        "translation": "He'd reset them, then leave them."
    },
    "57": {
        "startTime": 361.275,
        "endTime": 363.95,
        "transcript": "Kalngii tua-i yaqulegnek",
        "translation": "His reed bag [filled] with birds"
    },
    "58": {
        "startTime": 363.95,
        "endTime": 375.32,
        "transcript": "Imkunek yaqulpianek allgiarnek, kukumya'rnek-llu, kepaalegnek-llu-w' pilallilria, imartuluku utertaqluni.",
        "translation": "He would come home with it filled full with long-tailed ducks, black scoters, and probably greater scaups."
    },
    "59": {
        "startTime": 375.32,
        "endTime": 380.91,
        "transcript": "Arnat-llu pingnaquratullruut tamaani murilkeqarraallemni.",
        "translation": "Women would also subsist back when I first became observant."
    },
    "60": {
        "startTime": 380.91,
        "endTime": 383.76,
        "transcript": "Tua-i uitayuunateng.",
        "translation": "They weren't sedentary."
    },
    "61": {
        "startTime": 383.76,
        "endTime": 394.52,
        "transcript": "Caliarkateng tekitaqameng caliaqluki eritarluki, wall'u ulliggluki, wall'u imkut can'giiyagaat nuvluki agarrluki.",
        "translation": "When they arrived, they'd work on their chores, plucking feathers, or butchering them, or threading and hanging those little blackfish."
    },
    "62": {
        "startTime": 394.525,
        "endTime": 400.815,
        "transcript": "Ik'iki up'nerkami up'nerkaungraan neqliurluteng yuut imkut.",
        "translation": "In the spring, though it was spring, people back then would work on so many fish."
    },
    "63": {
        "startTime": 400.815,
        "endTime": 410.105,
        "transcript": "Kanaqlagcurluteng tuaten akikaarameggnek, kiingita up'nerkami akiketullruamegteki.",
        "translation": "They'd even hunt muskrats to earn money, since it was their only source of income in the spring."
    },
    "64": {
        "startTime": 411.165,
        "endTime": 419.255,
        "transcript": "Tua-i tayima im' qingangartaqata",
        "translation": "When they became pregnant"
    },
    "65": {
        "startTime": 420.265,
        "endTime": 427.16,
        "transcript": "Qingacuaranga'artaqata kanaqliit utertetullruut nunameggnun.",
        "translation": "When muskrats were in early pregnancy, they'd return to their villages."
    },
    "66": {
        "startTime": 427.16,
        "endTime": 431.71,
        "transcript": "Ataam tua-i uterrluteng up'nerkinrirluteng.",
        "translation": "They'd go home again, ending their spring camping."
    },
    "67": {
        "startTime": 431.71,
        "endTime": 436.33,
        "transcript": "Tua-i-ll' up'nerkinrirluteng nunameggnun tekicameng",
        "translation": "Then when their spring camps were over and they arrived in their villages"
    },
    "68": {
        "startTime": 437.095,
        "endTime": 444.885,
        "transcript": "Uitaqarraarluteng, tamakut neqliateng engelkarqaarluki Kusquqvagmun atrarluteng.",
        "translation": "After staying for a while, after putting away those fish they worked on, they'd go down to the Kuskokwim."
    },
    "69": {
        "startTime": 444.885,
        "endTime": 451.675,
        "transcript": "Uani tua-i Mamterillerni uitaaqluteng.",
        "translation": "They'd stay downriver in Bethel."
    },
    "70": {
        "startTime": 453.435,
        "endTime": 463.625,
        "transcript": "Mom-avet grandma-rani sister-aaqngamiu grandma-llra tuani tua-i kiagpak uitaaqluta.",
        "translation": "At your mother's grandma's, since their late grandma was her sister, we'd stay there all summer."
    },
    "71": {
        "startTime": 464.185,
        "endTime": 465.425,
        "transcript": "Tua-llu?",
        "translation": "How was that?"
    },
    "72": {
        "startTime": 466.52,
        "endTime": 479.37,
        "transcript": "Tua-ll' qanerturallerpeni ava-i qanqallruuten Nanvarnarrlagmi, Nanvarnarrlagmiungullruniluten.",
        "translation": "So, as you just spoke, you said that you were from Nanvarnarrlak."
    },
    "73": {
        "startTime": 479.49,
        "endTime": 485.02,
        "transcript": "Taum-qaa avatiini nunallret amllelallruut?",
        "translation": "Where there a lot of old settlements around there?"
    },
    "74": {
        "startTime": 485.02,
        "endTime": 487.02,
        "transcript": "Yugyalallruuq? Nuu?",
        "translation": "Were there a lot of people? No?"
    },
    "75": {
        "startTime": 488.525,
        "endTime": 494.735,
        "transcript": "Nunallret amllellrunritut. Enet amllellrunritut.",
        "translation": "There weren't a lot of settlements. There weren't a lot of houses."
    },
    "76": {
        "startTime": 494.735,
        "endTime": 498.55,
        "transcript": "Tua-i naaqucirluteng tua-i naaqutet.",
        "translation": "They were numbered."
    },
    "77": {
        "startTime": 498.55,
        "endTime": 505.37,
        "transcript": "Wangni waniwa waten umyuartequrarqami tangrruartura'arqamki",
        "translation": "To me, when I ponder and imagine them"
    },
    "78": {
        "startTime": 506.665,
        "endTime": 511.515,
        "transcript": "Tayima-llu qula cip'arrluku enet amllertaciqut.",
        "translation": "There'd probably be a little over ten houses."
    },
    "79": {
        "startTime": 512.165,
        "endTime": 518.195,
        "transcript": "Imkullrunritut, yugyallrunritut. Nunat tamarmeng yugyallrunritut.",
        "translation": "They weren't, you know, heavily populated. No village was heavily populated."
    },
    "80": {
        "startTime": 518.195,
        "endTime": 524.03,
        "transcript": "Nunacuarmiut tau͡gaam kiimeng keluqliput, kiimeng yugyallruut.",
        "translation": "Only Nunacuarmiut inland from us had a large population."
    },
    "81": {
        "startTime": 524.03,
        "endTime": 531.45,
        "transcript": "Ukut-llu Nunapicuarmiut qayuturraan-wa yui.",
        "translation": "And Nunapitchuk had few people."
    },
    "82": {
        "startTime": 531.455,
        "endTime": 535.865,
        "transcript": "Paingarmiut-wa call' qayuturraan-wa call' yuut.",
        "translation": "Paingarmiut also had few people."
    },
    "83": {
        "startTime": 535.865,
        "endTime": 542.795,
        "transcript": "Pingkut Atmaulluarmiut nuniita kiakaraani uitaluteng.",
        "translation": "They were just upriver from around Atmauthluak inland."
    },
    "84": {
        "startTime": 542.795,
        "endTime": 550.175,
        "transcript": "Nunait waten: Nunacuarmiut, Nanvarnarrlagmiut, Nunapicuarmiut",
        "translation": "Their settlements were like this: Nunacuarmiut, Nanvarnarrlagmiut, Nunapicuarmiut"
    },
    "85": {
        "startTime": 551.02,
        "endTime": 558.41,
        "transcript": "Ukut-llu Atmaulluarmiut kuigatni uitalriit.",
        "translation": "And Atmauthuak was in their river."
    },
    "86": {
        "startTime": 559.26,
        "endTime": 564.55,
        "transcript": "Cetamainguluteng waten nunaullruyaaqut, tau͡gaam yugyallrunritut.",
        "translation": "There were four villages like this, but they weren't heavily populated."
    },
    "87": {
        "startTime": 564.74,
        "endTime": 567.27,
        "transcript": "Yugyagpek'nateng.",
        "translation": "They weren't heavily populated."
    },
    "88": {
        "startTime": 567.52,
        "endTime": 573.56,
        "transcript": "Enepiarrlainaat-wa enait. Marayarrlainaat enait.",
        "translation": "Their houses were all traditional. Their houses were made of sod."
    },
    "89": {
        "startTime": 573.975,
        "endTime": 579.265,
        "transcript": "Tua-i waten log house-anek-llu tangssuunii.",
        "translation": "I would see log houses like this either."
    },
    "90": {
        "startTime": 579.265,
        "endTime": 589.195,
        "transcript": "Taukuk tau͡gaam angayuqaagka kiimek ellangellemni log house-amek enengqellruuk, elaturrarlutek-llu marayamek.",
        "translation": "My parents were the only ones with a log house in my earliest memories, and they had a sod entry porch."
    },
    "91": {
        "startTime": 589.195,
        "endTime": 591.815,
        "transcript": "Tua-i tuaten ayuqellruut.",
        "translation": "That's what they were like."
    },
    "92": {
        "startTime": 595.02,
        "endTime": 606.84,
        "transcript": "Makut-mi? Kuiget kuicuaraat-llu pavani atengqelartut.",
        "translation": "What about these? Rivers and creeks inland have names."
    },
    "93": {
        "startTime": 608.145,
        "endTime": 614.735,
        "transcript": "Maa-i-llu nalluyagulluki atrit ilait wangkuta ayagyuani.",
        "translation": "And now, some of us young people forgot their names."
    },
    "94": {
        "startTime": 614.735,
        "endTime": 618.125,
        "transcript": "Atrit-qaa nallunritaten? Aperyugngaaten?",
        "translation": "Do you know their names? Can you say them?"
    },
    "95": {
        "startTime": 618.125,
        "endTime": 623.835,
        "transcript": "Iciw' ilait Kakegglugmek qanlalriit cali-llu allanek.",
        "translation": "You know, some speak of Kakeggluk [Mucus] and others."
    },
    "96": {
        "startTime": 625.215,
        "endTime": 634.225,
        "transcript": "Atam elipailemku unitellruamku Akula, Akulem imkui nalluanka.",
        "translation": "You see, since I left the Akula region before I learned it, I don't know the [names of land and water] of the Akula region."
    },
    "97": {
        "startTime": 634.225,
        "endTime": 636.695,
        "transcript": "Nalluanka. (Ii-i.)",
        "translation": "I don't know them. (I see.)"
    },
    "98": {
        "startTime": 636.695,
        "endTime": 639.905,
        "transcript": "Iciw' nunakellrungramku",
        "translation": "You know, though I lived there"
    },
    "99": {
        "startTime": 639.905,
        "endTime": 651.455,
        "transcript": "Nasaurlucualleraulua waten anglirivailegma angayuqaagka cataurutellragni tamarmek ataucikun",
        "translation": "When I was a little girl like this before I grew up, when both of my parents passed away at the same time"
    },
    "100": {
        "startTime": 652.465,
        "endTime": 659.135,
        "transcript": "Atrallruunga uavet.",
        "translation": "I went down downriver."
    },
    "101": {
        "startTime": 659.565,
        "endTime": 668.495,
        "transcript": "Taukuk tau͡gaam ugkuk catairutellrek aanakellriit aulukellruagnga.",
        "translation": "But those two downriver who passed away, the mother and daughter took care of me."
    },
    "102": {
        "startTime": 682.045,
        "endTime": 687.44,
        "transcript": "Nani Kass'amek tangerqarraallrusit Kass'apiamek?",
        "translation": "Where did you first see a Caucasian, a Russian?"
    },
    "103": {
        "startTime": 687.44,
        "endTime": 693.36,
        "transcript": "Kass'amek-wa tua-i nani tangerqarraallrusit-llu, tuani-llu-qaa alingellruuten?",
        "translation": "Where did you first see a Caucasian, and were you scared then?"
    },
    "104": {
        "startTime": 693.755,
        "endTime": 702.525,
        "transcript": "Alingellrunritua. Uumek-gguq tangerqerraalallruukut Angliluaqallermek.",
        "translation": "I wasn't afraid. They said the first one we saw was Angliluaqalleq."
    },
    "105": {
        "startTime": 702.995,
        "endTime": 707.485,
        "transcript": "Angliluaqall[eq] kituullrulria?",
        "translation": "Angliluaqall[eq], who was (s)he?"
    },
    "106": {
        "startTime": 707.485,
        "endTime": 711.88,
        "transcript": "Tarraquratuluni pavani piciatun.",
        "translation": "He would roam anwhere inland."
    },
    "107": {
        "startTime": 711.88,
        "endTime": 717.76,
        "transcript": "Angliluaqallru[lliuq]. Naamell'. Kituullrulria ima tanem?",
        "translation": "Maybe Angliluaqalleq. I don't know. Who was (s)he again?"
    },
    "108": {
        "startTime": 717.765,
        "endTime": 720.895,
        "transcript": "Nalluyagutaqa-am tayim' atra.",
        "translation": "I've forgotten their name."
    },
    "109": {
        "startTime": 720.895,
        "endTime": 727.77,
        "transcript": "Yugtun qantuluni, waten tua-i tau͡gaam Kassauluni.",
        "translation": "(S)he spoke Yup'ik, but (s)he was Caucasian like this."
    },
    "110": {
        "startTime": 727.77,
        "endTime": 731.97,
        "transcript": "Nunanun waten ayagaurluni piciatun.",
        "translation": "(S)he would travel to various villages like this."
    },
    "111": {
        "startTime": 731.975,
        "endTime": 734.485,
        "transcript": "Qavartarraarlun' ayagaqluni.",
        "translation": "After spending the night, (s)he'd leave."
    },
    "112": {
        "startTime": 734.485,
        "endTime": 738.34,
        "transcript": "Aarnarqengraan-llu pekqurluni, pekqurluni.",
        "translation": "And though it was dangerous, (s)he always traveled."
    },
    "113": {
        "startTime": 738.34,
        "endTime": 743.16,
        "transcript": "Qayarluni waten malrugnek ukinelegnek.",
        "translation": "(S)he had a kayak like this with two cockpits."
    },
    "114": {
        "startTime": 743.605,
        "endTime": 746.785,
        "transcript": "Tua-i kiigkenka assigtaqlukek.",
        "translation": "Those were their only storage places."
    },
    "115": {
        "startTime": 746.99,
        "endTime": 753.41,
        "transcript": "Alikellrunritaqa. Alingyuitellruunga Kass'amek tangerqerrallemni.",
        "translation": "I wasn't afraid of them. I wasn't afraid when I first saw a Caucasian."
    },
    "116": {
        "startTime": 753.415,
        "endTime": 761.995,
        "transcript": "Tauna tau͡gaam tua-i tangerqerraallruaqa pavani up'nerkami, pekquralria tauna up'nerkami.",
        "translation": "That was the first one I saw inland in the spring, the one who always traveled in the spring."
    },
    "117": {
        "startTime": 763.86,
        "endTime": 769.36,
        "transcript": "Uani tau͡gaam cali kinguakun tanglallruunga",
        "translation": "But downriver after that, I also used to see"
    },
    "118": {
        "startTime": 769.365,
        "endTime": 777.855,
        "transcript": "Imkunek ciuqlirnek, ciuqlirnek missionary-nek:",
        "translation": "Those first, the firs missionaries:"
    },
    "119": {
        "startTime": 777.855,
        "endTime": 789.475,
        "transcript": "Kil'pagmek, Kil'pagnek, Qakinermek, au͡gna-wa cali Hincia-mek pilaqiit.",
        "translation": "Kil'pak, Kil'piit, Qakineq, and that one they called Hincia."
    },
    "120": {
        "startTime": 789.78,
        "endTime": 795.07,
        "transcript": "Tamakut tua-i Puciinaaq-llu tangerqerraalallruanka.",
        "translation": "Those and Puciinaaq were the first ones I saw."
    },
    "121": {
        "startTime": 795.07,
        "endTime": 798.94,
        "transcript": "Kass'at amllellrunritut uani Mamterillerni.",
        "translation": "There weren't a lot of Caucasians downriver in Bethel."
    },
    "122": {
        "startTime": 799.96,
        "endTime": 807.35,
        "transcript": "Yuut-llu acirayuameng Kass'at tamarmeng, Kass'arraat tamarmeng Yugtun aterluteng.",
        "translation": "And since Yupiit are good at giving names, every Caucasians, all of what Caucasians there were had Yup'ik names."
    },
    "123": {
        "startTime": 810.72,
        "endTime": 813.16,
        "transcript": "Canek atengqelallruat?",
        "translation": "What names did they have?"
    },
    "124": {
        "startTime": 813.365,
        "endTime": 817.595,
        "transcript": "Uussiiyurteńek tuaten ilait.",
        "translation": "Some were called [?Rare Cooked]."
    },
    "125": {
        "startTime": 817.705,
        "endTime": 820.615,
        "transcript": "Canek-ll' ima tanem?",
        "translation": "What else again?"
    },
    "126": {
        "startTime": 822.165,
        "endTime": 829.095,
        "transcript": "Peqlinek, Peqlinek tuaten, canek tuaten.",
        "translation": "Even Wrinkled from Soaking, and other things."
    },
    "127": {
        "startTime": 830.135,
        "endTime": 833.745,
        "transcript": "Parunek tuaten ilait.",
        "translation": "Some were even Small Bugs."
    },
    "128": {
        "startTime": 837.615,
        "endTime": 845.355,
        "transcript": "Acingssaullruut yullret tayima catairutellret.",
        "translation": "People back then who've passed on had silly names."
    },
    "129": {
        "startTime": 847.93,
        "endTime": 854.73,
        "transcript": "Tua-i piciatun aterpaggluki, Uqinrunek tuaten ilait.",
        "translation": "They would call them random things, even some were Seal Oil Containers."
    },
    "130": {
        "startTime": 860.735,
        "endTime": 873.405,
        "transcript": "Tua-ll' makut yuut qanruyutek'lallrit makunun ayagyuanun.",
        "translation": "Then the traditional wisdom people passed down to these young people."
    },
    "131": {
        "startTime": 873.405,
        "endTime": 880.435,
        "transcript": "Iciw' TV-tgun ilaitni tangvalalriaci makunek tegganernek qalarquralrianek.",
        "translation": "You know, you sometimes watch on TV elders giving instruction."
    },
    "132": {
        "startTime": 880.435,
        "endTime": 888.09,
        "transcript": "Waten tangercetaaliluki qanruyutnek piciatun tua-i Yuut piitnek.",
        "translation": "They make videos like this about various Yup'ik wisdom."
    },
    "133": {
        "startTime": 888.09,
        "endTime": 894.86,
        "transcript": "Tamakut-qaa wangkutnun ayagyuanun nalluyagutnarqenritut?",
        "translation": "Should we young people not forget those?"
    },
    "134": {
        "startTime": 895.61,
        "endTime": 905.95,
        "transcript": "Tua-i-w' ilumun qanruyutet, qanruyuteput wangkuta eneqaqa'aqluki pitulriakut.",
        "translation": "Indeed, we remember the traditional wisdom, our traditional wisdom."
    },
    "135": {
        "startTime": 905.955,
        "endTime": 910.05,
        "transcript": "Nalluyaguterrlainarpek'naki.",
        "translation": "We don't always forget them."
    },
    "136": {
        "startTime": 910.05,
        "endTime": 917.57,
        "transcript": "Makut maa-i ayagyuaput mat'um nalliini pisciigalilriatun ayuqut.",
        "translation": "It's like our young people these days can't do it anymore."
    },
    "137": {
        "startTime": 917.685,
        "endTime": 929.055,
        "transcript": "Wangkuta tang imumi waten nasaurluullemteńi tua-i canek inerquatullrukaitkut.",
        "translation": "You see, when we were girls back then, they would give us admonishments."
    },
    "138": {
        "startTime": 929.055,
        "endTime": 935.595,
        "transcript": "Nakukutesqevkenata-llu, kenkuraulluta-llu pisqelluta.",
        "translation": "And they told us not to fight each other, and treat each other with love."
    },
    "139": {
        "startTime": 936.13,
        "endTime": 941.7,
        "transcript": "Ilaput-llu tangnerrlugnarqengraata",
        "translation": "And though those around us look unpleasing"
    },
    "140": {
        "startTime": 941.7,
        "endTime": 953.72,
        "transcript": "Iciw' tua-i imkusqevkenaki assiilkelluki wall'u piyuumiinaki pisqevkenaki.",
        "translation": "You know, they told us not to treat them badly, or reject them."
    },
    "141": {
        "startTime": 953.725,
        "endTime": 958.735,
        "transcript": "Tau͡gaam naklekluki kenekluki pilaasqelluta.",
        "translation": "Instead, they told us to treat them with compassion and love."
    },
    "142": {
        "startTime": 958.915,
        "endTime": 971.335,
        "transcript": "Cali-llu waten: yuum-gguq camek qancurlauskakut waten ellami-llu piinanemteńi kiunrillaut-gguq.",
        "translation": "This too: they said that if someone says something bad to us while we're outside like this, we shouldn't reply."
    },
    "143": {
        "startTime": 971.47,
        "endTime": 974.1,
        "transcript": "Kiusqevkenaku.",
        "translation": "They told us not to reply."
    },
    "144": {
        "startTime": 974.18,
        "endTime": 978.96,
        "transcript": "Wangkuta maa-i qanruyuteput cali",
        "translation": "The traditional wisdom passed down to us now"
    },
    "145": {
        "startTime": 979.705,
        "endTime": 985.505,
        "transcript": "Arnaureskumta-llu, waten arnaureskumta",
        "translation": "And if we become women, if we become women like this"
    },
    "146": {
        "startTime": 985.82,
        "endTime": 994.49,
        "transcript": "Tua-i arnaurtellrianek maa-i niitelalriaci nasaurluyagaat makut waten arnaurtaqata.",
        "translation": "You hear about those becoming women when these little girls become women like this."
    },
    "147": {
        "startTime": 995.43,
        "endTime": 1000.51,
        "transcript": "Murilkelluta, murilkelluta pisqelluta.",
        "translation": "They told us to be careful."
    },
    "148": {
        "startTime": 1000.515,
        "endTime": 1006.23,
        "transcript": "Tan'gaurlurnun-llu caumateksaunata pilaasqelluta.",
        "translation": "They also told us not to gravitate to boys."
    },
    "149": {
        "startTime": 1006.23,
        "endTime": 1014.82,
        "transcript": "Atam-gguq, atam-gguq tan'gaurluum elpekekunikut qaillun ellirniartuq.",
        "translation": "Watch, they said, if a boy notices us, he will become abnormal."
    },
    "150": {
        "startTime": 1014.82,
        "endTime": 1019.8,
        "transcript": "Tamana tua-i alikluku wangkuta yuullruukut.",
        "translation": "We lived in fear of that."
    },
    "151": {
        "startTime": 1020.485,
        "endTime": 1028.68,
        "transcript": "Waten wangkutnek tau͡gaam nasaurluullgutkellriani-llu aipaqluta.",
        "translation": "We would only play by ourselves and with our fellow girls."
    },
    "152": {
        "startTime": 1028.68,
        "endTime": 1034.41,
        "transcript": "Tua-i makut wani tan'gaurluut",
        "translation": "These boys"
    },
    "153": {
        "startTime": 1034.54,
        "endTime": 1037.86,
        "transcript": "Angliriaqamta-wa tua-i",
        "translation": "At least when we grow up"
    },
    "154": {
        "startTime": 1038.275,
        "endTime": 1044.29,
        "transcript": "Waten mikluta aipaq'langramta cayuitut, cayuitut.",
        "translation": "Though we play with each other when we're small like this, nothing happens to them."
    },
    "155": {
        "startTime": 1044.29,
        "endTime": 1050.64,
        "transcript": "Tau͡gaam waten temigiqerrluki tamana inerquutekellruat.",
        "translation": "But when they'd [?grown], they'd admonish against that."
    },
    "156": {
        "startTime": 1050.64,
        "endTime": 1060.5,
        "transcript": "Inerquutek'lallruat wangkutnun arnanun tan'gaurluq caukussagaasqevkenaku.",
        "translation": "They would admonish us women against interacting with a boy."
    },
    "157": {
        "startTime": 1060.505,
        "endTime": 1069.68,
        "transcript": "Atam-gguq imkungniartuq qaillun-llu ellirluni, kiituani qaillun ellirtuq.",
        "translation": "Watch, they said, he would become abnoramal, until eventually he becomes abominable."
    },
    "158": {
        "startTime": 1069.68,
        "endTime": 1073.28,
        "transcript": "Tua-i-gguq arnaq tuquungan.",
        "translation": "They said it's because a woman is death."
    },
    "159": {
        "startTime": 1073.285,
        "endTime": 1078.695,
        "transcript": "Waten qanrut'lallruitkut.",
        "translation": "This is what they'd tell us."
    },
    "160": {
        "startTime": 1083.005,
        "endTime": 1092.765,
        "transcript": "Cali maa-i-rpak makut ayagyuat mikelngullraat elitnaunguq, Kass'acetun-llu qalarcaurrluteng amlleret.",
        "translation": "These days, these young people, children, are going to school, and many have started speaking English."
    },
    "161": {
        "startTime": 1093.22,
        "endTime": 1099.4,
        "transcript": "Qalarutellriani-llu ayagyuat ilait taringyuunateng, camek qalaruciinateng.",
        "translation": "And when spoken to, some youth do not understand, don't know what they're being told."
    },
    "162": {
        "startTime": 1099.405,
        "endTime": 1105.605,
        "transcript": "Tamana-qaa atawaunrituq cagmariinallra Yugcetun qalarcaraq?",
        "translation": "Is it unbeneficial to lose the Yup'ik language?"
    },
    "163": {
        "startTime": 1105.68,
        "endTime": 1117.24,
        "transcript": "Ilumun tua-i tamana Yugtun qallacaraq, makunun tutgaramteńun atawaunrituq.",
        "translation": "Indeed, it's unbeneficial for our grandchildren [to lose] that Yup'ik language."
    },
    "164": {
        "startTime": 1117.245,
        "endTime": 1126.295,
        "transcript": "Wiinga ukut tutgara'urluunka wiinga qitevcuilama, qitevqurayuilama, qitevcuilama",
        "translation": "My grandchildren, since I don't speak English, since I don't always speak English"
    },
    "165": {
        "startTime": 1126.295,
        "endTime": 1130.645,
        "transcript": "Yugtun qanruteqtarturalaryaaqanka.",
        "translation": "I always speak to them in Yup'ik."
    },
    "166": {
        "startTime": 1130.645,
        "endTime": 1140.74,
        "transcript": "Tau͡gaam taringetuyaaqluteng, tau͡gaam akilii taringesciiganaku, taringesciigataqluku.",
        "translation": "They do understand, but they can't understand some of it."
    },
    "167": {
        "startTime": 1140.74,
        "endTime": 1145.18,
        "transcript": "Tamarmeng tua-i qanrutellriani taringtuluteng.",
        "translation": "All of them understand when spoken to [in Yup'ik]."
    },
    "168": {
        "startTime": 1145.185,
        "endTime": 1155.54,
        "transcript": "Pivakaqerluteng tua͡gaam ca pisqellriani, tua-i-ll' imkukaunateng, camek tegukaunateng.",
        "translation": "But sometimes, when asked to do something, they don't know what to take."
    },
    "169": {
        "startTime": 1155.54,
        "endTime": 1165.42,
        "transcript": "Ellimellriani-llu taumek, tauna aperluku ellimellriani imna piarkani cauciinaku tua-i.",
        "translation": "And when asked for something that is specifically said, they don't know what they're asked for."
    },
    "170": {
        "startTime": 1165.425,
        "endTime": 1178.54,
        "transcript": "Tau͡gaam amlleq ukulleraat tutgarama, amlleq qaneryaraq wiinga qanruqu'uryuamteng nallunritaat.",
        "translation": "But many of my granchildren here, since I always speak to them, they know much of the language."
    },
    "171": {
        "startTime": 1178.54,
        "endTime": 1186.62,
        "transcript": "Tau͡gaam wiinga assikeksaitelaryaaqanka makut Yupiat, Yupiat waten",
        "translation": "But I don't like it when these Yupiat, Yupiat like this"
    },
    "172": {
        "startTime": 1186.625,
        "endTime": 1197.665,
        "transcript": "Nulirqellriik Yupiarulutek, avguvkenani-llu, aipaa-llu call' nulirra wall' aanii wall' maurlua avguvkenani",
        "translation": "A married Yup'ik couple, and this is not half, and their spouse or wife or mother or grandmother is not half"
    },
    "173": {
        "startTime": 1198.59,
        "endTime": 1208.85,
        "transcript": "Waten qitevquraulluki, mikluki ayagluki qitevquraulluki, wiinga assikenritaqa tamana.",
        "translation": "Always speaking to them in English, speaking English from when they're small, I don't like that."
    },
    "174": {
        "startTime": 1209.985,
        "endTime": 1222.935,
        "transcript": "Waten qanrucaaqellriani, qanrucaaqellriani tua-i-ll' uitaluni tua-i camek pisciiganani.",
        "translation": "Then when they're spoken to like this, they stay still unable to do anything."
    },
    "175": {
        "startTime": 1222.935,
        "endTime": 1225.47,
        "transcript": "Ca taringesciiganaku.",
        "translation": "They can't understand anything."
    },
    "176": {
        "startTime": 1225.47,
        "endTime": 1234.56,
        "transcript": "Waten qit'vuquranrilnge'rmi, Yugtun enemi, enemini qanruqu'urquniu Yugtun",
        "translation": "Without speaking English to them like this, Yup'ik at home, if they speak to them in Yup'ik at their home"
    },
    "177": {
        "startTime": 1234.56,
        "endTime": 1238.91,
        "transcript": "Yugtun qanerturciquq.",
        "translation": "They will always speak Yup'ik."
    },
    "178": {
        "startTime": 1238.91,
        "endTime": 1245.39,
        "transcript": "Tua-i-llu elitnauquni cali nutaan Kass'atun, Kass'acetun elitnaurluni.",
        "translation": "Then when they go to school, they will learn in English."
    },
    "179": {
        "startTime": 1245.395,
        "endTime": 1249.81,
        "transcript": "Nauw' elpeci anglicallrukiici",
        "translation": "Look at how they raised you"
    },
    "180": {
        "startTime": 1249.81,
        "endTime": 1257.95,
        "transcript": "Tua-i tamarpeci nalluvkenaku, ilaten-llu imkut nalluvkenaki ukut tan'gaurluut.",
        "translation": "All of you know it, and you know your fellow boys here."
    },
    "181": {
        "startTime": 1258.175,
        "endTime": 1266.85,
        "transcript": "Arenqiallugtevkenateng Yugtun qallalluteng, Kass'atun qallalluteng. Arenqiallugtevkenateng.",
        "translation": "They have no problems speaking Yup'ik, speaking English. They have no problems."
    },
    "182": {
        "startTime": 1266.85,
        "endTime": 1277.95,
        "transcript": "Maa-i tau͡gken mat'um nalliini makut maa-i irniamta, irniamta yuit arenqiallugingaluteng.",
        "translation": "These days, however, our children's children have a problem."
    },
    "183": {
        "startTime": 1277.955,
        "endTime": 1280.575,
        "transcript": "Assiinateng tua-i wangni.",
        "translation": "They're [situation] is bad to me."
    },
    "184": {
        "startTime": 1284.25,
        "endTime": 1287.21,
        "transcript": "Tua-i-w' time-airtellinilriakuk.",
        "translation": "Well, we've run out of time."
    },
    "185": {
        "startTime": 1287.215,
        "endTime": 1289.565,
        "transcript": "Ii-i, kitak'-wa, quyana.",
        "translation": "Okay, well then, thank you."
    },
    "186": {
        "startTime": 1289.565,
        "endTime": 1291.6,
        "transcript": "Ii-i, quyanaqvaa cakneq.",
        "translation": "Yes, thank you very much."
    },
    "187": {
        "startTime": 1291.6,
        "endTime": 1294.74,
        "transcript": "Puqialeng'e'rma tua-i. (Nuu, assirtuq.)",
        "translation": "Though I'm inarticulate. (No, it's good.)"
    },
    "188": {
        "startTime": 1297.495,
        "endTime": 1305.265,
        "transcript": "Henry Young-aq-llu atam qanlartuq Kass'allraat iliitnek Erimek-gguq aterluni.",
        "translation": "Henry Young also says, you see, that one Caucasian was named Milt Sac."
    },
    "189": {
        "startTime": 1305.265,
        "endTime": 1309.4,
        "transcript": "Erimek-llu, aren nalluyagutelliniaqa Eriq-llu.",
        "translation": "And Milt Sac, oh my, I forgot about Milt Sac."
    },
    "190": {
        "startTime": 1309.4,
        "endTime": 1314.75,
        "transcript": "Eriq tauna tua-i Kass'arra'urluq qercurpak tua-i.",
        "translation": "Milt Sac, that dear Caucasian, was very pale."
    },
    "191": {
        "startTime": 1314.75,
        "endTime": 1317.71,
        "transcript": "Caunani, kaviinani tua-i.",
        "translation": "He had no [color], no blush."
    },
    "192": {
        "startTime": 1317.715,
        "endTime": 1323.245,
        "transcript": "Waten tua-i ing'utun qatertaluni agayuvigtun.",
        "translation": "Like this, (s)he was as pale as that church over there."
    },
    "193": {
        "startTime": 1323.495,
        "endTime": 1326.145,
        "transcript": "Here, I'll take that. (Ii-i.) Quyana.",
        "translation": "Here, I'll take that. (Okay.) Thank you."
    },
    "194": {
        "startTime": 1326.145,
        "endTime": 1327.365,
        "transcript": "Ii-i.",
        "translation": "You're welcome."
    }
};